/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Builders_Signal_Last_ActivityInputs */

const en_directory_builders_signal_last_activity = /** @type {(inputs: Directory_Builders_Signal_Last_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last activity`)
};

const zh_directory_builders_signal_last_activity = /** @type {(inputs: Directory_Builders_Signal_Last_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近活跃`)
};

/**
* | output |
* | --- |
* | "Last activity" |
*
* @param {Directory_Builders_Signal_Last_ActivityInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_builders_signal_last_activity = /** @type {((inputs?: Directory_Builders_Signal_Last_ActivityInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Builders_Signal_Last_ActivityInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_builders_signal_last_activity(inputs)
	return zh_directory_builders_signal_last_activity(inputs)
});
export { directory_builders_signal_last_activity as "directory.builders.signal_last_activity" }